import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

function Header() {
  const location = useLocation();

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-primary text-white shadow-sm"
    >
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img 
              src="https://letcheck.b-cdn.net/944/bild-logo-final-dunkel-1726774068395.png" 
              alt="Logo" 
              className="h-8 w-auto"
            />
            <h1 className="text-xl font-semibold font-rubik text-white">
              Kreuzworträtsel
            </h1>
          </Link>
        </div>
      </div>
    </motion.header>
  );
}

export default Header;